// Client state is not proof: the API independently checks its persisted receipt.
export function recordedNotice(form,policy){
 return !!policy&&form.aydinlatmaBilgilendirildi===true&&form.aydinlatmaMetniId===policy.id&&!!form.aydinlatmaTarihi;
}
export function noticeSelection(form,policy,lang){
 const selected=recordedNotice(form,policy)||(form.kvkk===true&&form.onayMetniId===policy.id&&form.onayMetniDil===lang);
 return {kvkk:selected,onayMetniId:selected?policy.id:null,onayMetniDil:lang};
}
